import Vue from "vue";
import VueRouter from "vue-router";
import NewLayout from "../views/NewLayout/Layout";
import { checkAccess, clearCookies, getToken, checkTokenExpiry } from "../utils/tokenCheck.js";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/",
    component: NewLayout,
    redirect: "/dashboard",
    meta: {
      title: "NewHome",
    },
    children: [
      {
        path: "/tc/:certificateCode",
        name: "PublicCertificate",
        component: () => import("../routings/PublicCertificate.vue"),
      },
      // {
      //   path: "/certificatev1",
      //   name: "Certificate",
      //   component: () => import("../routings/Certificate.vue"),
      // },
      {
        path: "courses",
        name: "Courses",
        component: () =>
          import(
            "../views/TrainingFolder/MarketPlace/components/MarketPlaceLaptop.vue"
          ),
      },
      {
        path: "marketplace",
        name: "MarketPlace",
        component: () =>
          import("../views/TrainingFolder/MarketPlace/MarketPlace.vue"),
      },
      {
        path: "filteredcourses",
        name: "FilteredCourses",
        component: () =>
          import("../views/TrainingFolder/Course/FilteredCourses.vue"),
      },
      {
        path: "filteredcoursesview",
        name: "FilteredCoursesView",
        component: () =>
          import("../views/TrainingFolder/FilteredCoursesView.vue"),
      },
      {
        path: "coursedetail/:courseID",
        name: "CourseDetail",
        component: () =>
          import("../views/TrainingFolder/CourseDetail/CourseDetail.vue"),
      },
      {
        path: "courseview/:courseID",
        name: "CourseView",
        component: () =>
          import("../views/TrainingFolder/Course/CourseView.vue"),
      },
      {
        path: "mobilecourse",
        name: "mobilecourse",
        component: () =>
          import(
            "../views/TrainingFolder/Dashboard/components/DashboardMobile.vue"
          ),
      },
      // {
      //   path: "community",
      //   name: "Community",
      //   component: () =>
      //     import("../views/TrainingFolder/Community/CommunityLandingPage.vue"),
      // },
      {
        path: "communitymobile",
        name: "communitymobile",
        component: () =>
          import("../views/TrainingFolder/Community/CommunityMobile.vue"),
      },
      {
        path: "thread",
        name: "Thread",
        component: () =>
          import("../views/TrainingFolder/Community/Threads.vue"),
      },
      {
        path: "community",
        name: "CommunityView",
        component: () =>
          import("../views/TrainingFolder/Community/CommunityView.vue"),
      },
      {
        path: "review/:courseID",
        name: "Review",
        component: () => import("../views/TrainingFolder/Reviews/Review.vue"),
      },
      {
        path: "Mobilereview",
        name: "Mobilereview",
        component: () =>
          import("../views/TrainingFolder/Reviews/components/ReviewMobile.vue"),
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () =>
          import("../views/TrainingFolder/Dashboard/Dashboard.vue"),
      },
      {
        path: "popularsidebar",
        name: "PopopularSidebar",
        component: () =>
          import("../views/TrainingFolder/Course/PopularSidebar.vue"),
      },
      {
        path: "instructor",
        name: "Instructor",
        component: () => import("../routings/Instructor.vue"),
      },
      {
        path: "mobilemarketplace",
        name: "MobileMarketPlace",
        component: () =>
          import(
            "../views/TrainingFolder/MarketPlace/components/MarketPlaceMobile.vue"
          ),
      },
      {
        path: "mobilefilteredcourses",
        name: "MobileFilteredCourses",
        component: () =>
          import("../views/TrainingFolder/MobileFilteredCourses.vue"),
      },
      {
        path: "mobilefilename",
        name: "MobileFileName",
        component: () => import("../views/TrainingFolder/MobileFileName.vue"),
      },
      {
        path: "certificate",
        name: "Certificate",
        component: () =>
          import("../views/TrainingFolder/Certificates/Certificate.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: '/training',
  routes,
});

export default router;

// To avoid Duplicate Navigation
const onError = (e) => {
  // avoid NavigationDuplicated
  if (e.name !== "NavigationDuplicated") throw e;
};

// keep original function
const _push = router.__proto__.push;
// then override it
router.__proto__.push = function push(...args) {
  try {
    const op = _push.call(this, ...args);
    if (op instanceof Promise) op.catch(onError);
    return op;
  } catch (e) {
    onError(e);
  }
};

router.beforeEach((to, from, next) => {
    if(to.name == 'PublicCertificate' || to.name == 'CourseDetail'){
      next()
    }
    else if(checkAccess()){
      const hasToken = getToken();
      const expiryTime = checkTokenExpiry();
      if (hasToken && expiryTime) {
        next();
      }
      else{
        clearCookies();
        // location.replace("http://localhost:8080/login");
        location.replace("https://app.hire3x.com/login");
      }
    }
    else{
      clearCookies();
      // location.replace("http://localhost:8080/login");
      location.replace("https://app.hire3x.com/login");
    }
})
